var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgImgBgCube(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 38,
    height: 32,
    fill: "none",
    viewBox: "0 0 38 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#BAE0EE",
    stroke: "#D1DDE2",
    strokeLinejoin: "round",
    d: "M1.357 3.541L19.145 1 36.932 3.54 19.145 6.082 1.357 3.541z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#C3E7F1",
    stroke: "#C3E7F1",
    strokeLinejoin: "round",
    d: "M1.357 27.464V3.541l17.788 2.54v24.776L1.357 27.464z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6986CB",
    stroke: "#6986CB",
    strokeLinejoin: "round",
    d: "M36.643 27.464l.289-23.923-17.788 2.54v24.776l17.499-3.393z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "url(#paint0_linear_159_33)",
    strokeLinecap: "round",
    d: "M1.357 3.54L18.51 6.083",
    opacity: 0.5
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_159_33",
    x1: 5.169,
    x2: 19.145,
    y1: 4.176,
    y2: 6.082,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgImgBgCube);
export default __webpack_public_path__ + "static/media/img-bgCube.bdc2fa232ac585d976066f150b11e228.svg";
export { ForwardRef as ReactComponent };